import React from "react";
import { Box, Typography } from "@mui/material";

const PURPLE = "#661BB9";

const CustomTooltip = ({ tooltip, chartType }: any) => {
  const {
    title,
    body,
    caretX = 0,
    caretY = 0,
    success,
    allrequest,
  } = tooltip || {};

  const isNearLeftEdge = caretX < 100;
  const isNearBottom = caretY > 200;
  const isNearTop = caretY < 0;
  const isNearRightEdge = caretX > 878;
  const tooltipStyle = React.useMemo(
    () => ({
      position: "absolute",
      top: isNearBottom ? caretY - 160 : isNearTop ? caretY + 160 : caretY,
      left: isNearLeftEdge
        ? caretX + 140
        : isNearRightEdge
        ? caretX - 80
        : caretX - 30,
      pointerEvents: "none",
      minWidth: "240px",
      zIndex: 100,
      borderRadius: "12px",
      backgroundColor: "#fff",
      boxShadow: "0px 8px 28px rgba(99, 91, 255, 0.22)",
      border: `1px solid rgba(99, 91, 255, 0.14)`,
      overflow: "hidden",
    }),
    [caretX, caretY, isNearBottom, isNearLeftEdge]
  );

  if (!tooltip || !title || !body) return null;

  return (
    <Box sx={tooltipStyle}>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "14px 16px",
          background: `linear-gradient(135deg, ${PURPLE}, #8456d6)`,
        }}
      >
        <Typography
          sx={{
            color: "#fff",
            fontSize: "15px",
            fontWeight: 600,
          }}
        >
          {title}
        </Typography>
      </Box>

      {/* Content */}
      <Box sx={{ padding: "14px 16px" }}>
        <Typography
          sx={{
            color: "#2f2f2f",
            fontSize: "14px",
            marginBottom: "10px",
          }}
        >
          {body}
        </Typography>

        {chartType !== "orders" ? (
          <>
            <Typography sx={{ color: "#555", fontSize: "14px" }}>
              {allrequest}
            </Typography>
            <Typography
              sx={{
                color: PURPLE,
                fontSize: "14px",
                fontWeight: 600,
              }}
            >
              {success}
            </Typography>
          </>
        ) : (
          <Typography
            sx={{
              color: PURPLE,
              fontSize: "14px",
              fontWeight: 600,
            }}
          >
            {success}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default React.memo(CustomTooltip);
